import React, { useState, useRef } from 'react';

// Componentes.
import {
  Button,  
  Grid,
  Stack,
  Typography,
  Box,
  Modal,
  FormControl,
  IconButton,  
  OutlinedInput,
  InputAdornment,
  InputLabel
} from '@mui/material';

// Componentes
import { CustomStyles } from '../styles/ModalStyles';

// Iconos
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';

// Validador de contraseñas
import validator from 'validator';
import LoginService from '../../services/loginService';
import msgAlerta from '../../scripts/alert';

const ModalCambioContrasena = ({ usuario, setOpenModal, openModal, setLoading }) => {
  const inputEls = useRef([])

  const [showPassword, setShowPassword] = useState(false)
  const [showPassword2, setShowPassword2] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorMessage2, setErrorMessage2] = useState('')
  const [showSuccess, setShowSuccess] = useState('')
  const [showSuccess2, setShowSuccess2] = useState('')
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')

  //
  const handleClickShowPassword = () => setShowPassword((show) => !show)
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show)

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  const validatePwd = (value) => {
    try {      
      setPassword(value)
      
      if (!value) {
        setErrorMessage('')
        return
      }

      if (value.trim() !== password2.trim()) {
        setErrorMessage2('Las contraseñas no coinciden')
        setShowSuccess2('red')        
      } else {
        setErrorMessage2('Las contraseñas coinciden')
        setShowSuccess2('green')
      }
  
      if (validator.isStrongPassword(value, {
        minLength: 8, minLowercase: 1,
        minUppercase: 1, minNumbers: 1, minSymbols: 1
      })) {
        setErrorMessage('Es una contraseña segura')
        setShowSuccess('green')
      } else {
        setErrorMessage('No es una contraseña segura')
        setShowSuccess('red')
      }
      
    } catch (error) {
      console.error(error)
    }
  }

  const validatePwd2 = (value) => {
    try {
      setPassword2(value)
      
      if (!value) {
        setErrorMessage2('')
        return
      }      

      if (password.trim() !== value.trim()) {
        setErrorMessage2('Las contraseñas no coinciden')
        setShowSuccess2('red')
        return
      }
      
      setErrorMessage2('Las contraseñas coinciden')
      setShowSuccess2('green')
    } catch (error) {
      console.error(error)
    }
  }

  
  const guardarCambios = async () => {
    try {
      const data = {
        userLogin: usuario,
        password: password,
        password2: password2
      }

      if (!data.userLogin) {
        alert('El usuario está vacío')
        inputEls.current['nombre'].focus()
        return
      }

      if (!data.password) {
        alert('Digite la contraseña')
        inputEls.current['contrasena'].focus()
        return
      }

      if (!data.password2) {
        alert('Digite la confirmación de contraseña')
        inputEls.current['contrasena2'].focus()
        return
      }

      if (data.password !== data.password2) {
        alert('Las contraseñas no coinciden')        
        return
      }

      if (showSuccess === 'red') {
        alert('La contraseña no cumple con los requisitos de validación')
        return
      }

      setOpenModal(false)
      setLoading(true)
  
      LoginService.ChangePassword(data)
        .then(async (response) => {
          setTimeout(() => {
            setLoading(false)
                        
            if (!response) {              
              msgAlerta('Error de conexión con la API', 'Consulte al administrador del sitio.', 'error')
              return
            }
            
            const dataResponse = response.Data

            if (response.Codigo === 1) {
              localStorage.setItem('accessToken', dataResponse.Token)
              localStorage.setItem('user', JSON.stringify(dataResponse))
                            
              msgAlerta('Cambio de contraseña', response.Mensaje, 'info', () => window.location.href = '/home', false)
            } else {
              msgAlerta('Error al cambiar contraseña', response.Mensaje, 'warning')
            }
           
          }, 1000)
        })
        .catch((error) => {
          alert(`Error: ${error}`)
          setLoading(false)
        })
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    try {
      setErrorMessage('')
      setErrorMessage2('')
      setPassword('')
      setPassword2('')      
      setOpenModal(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div>
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition        
        slotProps={{
          backdrop: {
            timeout: 1000,
          }
        }}
        >
        <Box sx={CustomStyles} className='dv-cambio-pwd'>
          <Typography id="modal-modal-title" className='mb-4' textAlign={'center'} variant="h4" component="h2">
            Cambio de contraseña            
          </Typography>

          <Grid container spacing={1}>            

            <Grid item xs={12} md={12} className='my-2'>
              <FormControl sx={{ width: '100%' }} variant="outlined">
                <InputLabel
                  htmlFor="outlined-adornment-password"                  
                >
                  Contraseña
                </InputLabel>
                <OutlinedInput                  
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  className='h-input'
                  placeholder='Digita la nueva contraseña'
                  required
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      <LockIcon color='info' />
                    </InputAdornment>
                  }
                  label="Password"
                  name='contrasena'
                  onChange={(e) => validatePwd(e.target.value)}
                  inputRef={(el) => (inputEls.current['contrasena'] = el)}
                />
                {
                  errorMessage === ''
                  ? 
                  null
                  : 
                  <span style={{ fontWeight: 'bold', color: showSuccess }}>{errorMessage}</span>
                }
              </FormControl>
            </Grid>

            <Grid item xs={12} md={12} className='my-2'>
              <FormControl sx={{ width: '100%' }} variant="outlined">
                <InputLabel
                  htmlFor="outlined-adornment-password"                  
                >
                  Confirmar contraseña
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword2 ? 'text' : 'password'}
                  className='h-input'
                  placeholder='Confirma la contraseña'
                  required
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      <LockIcon color='info' />
                    </InputAdornment>
                  }
                  label="Password"
                  name='contrasena2'
                  onChange={(e) => validatePwd2(e.target.value)}
                  inputRef={(el) => (inputEls.current['contrasena2'] = el)}
                />
                {
                  errorMessage2 === ''
                  ? 
                  null
                  : 
                  <span style={{ fontWeight: 'bold', color: showSuccess2 }}>{errorMessage2}</span>
                }
              </FormControl>
            </Grid>            
          </Grid>          
      
          <Stack spacing={2} direction="row-reverse" marginTop={2}>
            <Button variant="contained" className='text-transform-none' onClick={guardarCambios}>
              Guardar cambios
            </Button>
            <Button variant="outlined" className='text-transform-none' onClick={handleClose}>
              Cancelar
            </Button>
          </Stack>
        </Box>
      </Modal>    
    </div>
  )
}

export default ModalCambioContrasena;